class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M5.029 8.94c.154.037.311.057.471.06.397-.003.783-.12 1.114-.34l1.609 1.434a1.944 1.944 0 0 0-.1 1.586 2.005 2.005 0 0 0 1.866 1.343 2.004 2.004 0 0 0 1.897-1.3 1.998 1.998 0 0 0-.577-2.223l1.271-2.546c.5.112 1.026.017 1.454-.265A2.001 2.001 0 1 0 11.69 6.5l-1.27 2.543A1.906 1.906 0 0 0 10 9c-.4 0-.786.117-1.117.34L7.274 7.903a1.939 1.939 0 0 0 .1-1.583 2.004 2.004 0 0 0-1.848-1.346 2.001 2.001 0 0 0-1.377 3.489L2 12.5V1H1v13a1 1 0 0 0 1 1h13v-1H2.334L5.03 8.94ZM13 4a1 1 0 1 1 .001 1.999A1 1 0 0 1 13 4Zm-2 7a1.001 1.001 0 1 1-2.002-.002A1.001 1.001 0 0 1 11 11ZM5.5 6a1 1 0 1 1 .001 1.999A1 1 0 0 1 5.5 6Z"></path></svg>';
  }
}
const t = "pi-mod-period-statistics";
customElements.get(t) || customElements.define(t, s);
export {
  s as default
};
